<template>
    <navBar title="Ares - Excel Exports" :home="true" type="excel" />
</template>

<script>
    import navBar from '@/components/ui/navbars/navbar.vue';

    export default {
        components: {
            navBar,
        },
    }
</script>
